import { type HotkeyLayer } from '@/ui/utilities/hotkey/types/HotkeyLayer';

// App-wide shortcuts keep working next to the side panel, but stop while an
// overlay (command menu, dialog, menu) is open.
export const PAGE_HOTKEY_LAYERS: readonly HotkeyLayer[] = [
  'page',
  'side-panel',
];
